import {
  ADD_AIRPORT_FAILURE,
  ADD_AIRPORT_REQUEST,
  ADD_AIRPORT_SUCCESS,
  FETCH_AIRPORTS_FAILURE,
  FETCH_AIRPORTS_REQUEST,
  FETCH_AIRPORTS_SUCCESS,
  DELETE_AIRPORT_REQUEST,
  DELETE_AIRPORT_SUCCESS,
  DELETE_AIRPORT_FAILURE,
  UPDATE_AIRPORT_REQUEST,
  UPDATE_AIRPORT_SUCCESS,
  UPDATE_AIRPORT_FAILURE,
  VIEW_AIRPORT_FAILURE,
  VIEW_AIRPORT_REQUEST,
  VIEW_AIRPORT_SUCCESS,
  FETCH_ALL_AIRPORT,
  FETCH_ALL_AIRPORT_REQUEST,
  FETCH_ALL_AIRPORT_SUCCESS,
  FETCH_ALL_AIRPORT_FAILURE,
  RESET_AIRPORT_STATE,
  UPDATE_AIRPORT_APPROVAL_STATUS_REQUEST,
  UPDATE_AIRPORT_APPROVAL_STATUS_SUCCESS,
  UPDATE_AIRPORT_APPROVAL_STATUS_FAILURE,
  APPROVE_AIRPORT_UPDATE_REQUEST,
  APPROVE_AIRPORT_UPDATE_SUCCESS,
  APPROVE_AIRPORT_UPDATE_FAILURE,
} from "../types/airportTypes";

export const addAirportRequest = (airportData) => ({
  type: ADD_AIRPORT_REQUEST,
  payload: airportData,
});

export const addAirportSuccess = (message) => ({
  type: ADD_AIRPORT_SUCCESS,
  payload: message,
});

export const addAirportFailure = (error) => ({
  type: ADD_AIRPORT_FAILURE,
  payload: { message: error.message || "An error occurred" },
});

export const fetchAirportsRequest = (payload) => ({
  type: FETCH_AIRPORTS_REQUEST,
  payload,
});

export const fetchAirportsSuccess = (airports) => ({
  type: FETCH_AIRPORTS_SUCCESS,
  payload: airports,
});
export const fetchAirportsFailure = (error) => ({
  type: FETCH_AIRPORTS_FAILURE,
  payload: error,
});
export const deleteAirportRequest = (airportId) => ({
  type: DELETE_AIRPORT_REQUEST,
  payload: airportId,
});
export const deleteAirportSuccess = (airportId) => ({
  type: DELETE_AIRPORT_SUCCESS,
  payload: airportId,
});
export const deleteAirportFailure = (error) => ({
  type: DELETE_AIRPORT_FAILURE,
  payload: error,
});
export const updateAirportRequest = (airportId, airportData) => ({
  type: UPDATE_AIRPORT_REQUEST,
  payload: { airportId, airportData },
});
export const updateAirportSuccess = (message) => ({
  type: UPDATE_AIRPORT_SUCCESS,
  payload: message,
});
export const updateAirportFailure = (error) => ({
  type: UPDATE_AIRPORT_FAILURE,
  payload: error,
});
export const resetAirportState = () => ({
  type: RESET_AIRPORT_STATE,
});
export const viewAirportRequest = (id) => ({
  type: VIEW_AIRPORT_REQUEST,
  payload: id,
});
export const viewAirportSuccess = (payload) => ({
  type: VIEW_AIRPORT_SUCCESS,
  payload,
});
export const viewAirportFailure = (payload) => ({
  type: VIEW_AIRPORT_FAILURE,
  payload,
});
export const fetchAllAirportRequest = () => ({
  type: FETCH_ALL_AIRPORT_REQUEST,
});
export const fetchAllAirportSuccess = (payload) => ({
  type: FETCH_ALL_AIRPORT_SUCCESS,
  payload,
});
export const fetchAllAirportFailure = (payload) => ({
  type: FETCH_ALL_AIRPORT_FAILURE,
  payload,
});
export const updateAirportApprovalStatusRequest = () => ({
  type: UPDATE_AIRPORT_APPROVAL_STATUS_REQUEST,
});

export const updateAirportApprovalStatusSuccess = (data) => ({
  type: UPDATE_AIRPORT_APPROVAL_STATUS_SUCCESS,
  payload: data,
});

export const updateAirportApprovalStatusFailure = (error) => ({
  type: UPDATE_AIRPORT_APPROVAL_STATUS_FAILURE,
  payload: error,
});

export const approveAirportUpdateRequest = (airportId) => ({
  type: APPROVE_AIRPORT_UPDATE_REQUEST,
  payload: airportId,
});

export const approveAirportUpdateSuccess = (response) => ({
  type: APPROVE_AIRPORT_UPDATE_SUCCESS,
  payload: response,
});

export const approveAirportUpdateFailure = (error) => ({
  type: APPROVE_AIRPORT_UPDATE_FAILURE,
  payload: error,
});
